<template>
    <div style="padding: 50px;">
        <h2>加减乘除操作：0.3 （+—*/）0.1 结果展示:</h2>
        <div v-html="code"></div>
        {{d1}}
        <br>
        {{d2}}
        <br>
        {{d3}}
        <br>
        {{d4}}
        <br>
        <h5>其余的操作，比如，取余数，四舍五入，取模，绝对值等，查看官网操作：
            <a href="http://mikemcl.github.io/big.js/" target="_blank">big.js官网</a>
        </h5>
    </div>
</template>
<script>
    import big from 'big.js'
    export default {
        data(){
            return {
                code:`
                import big from 'big.js'<br>
                var n1 = 0.3;<br>
            var n2 = "0.1";<br>
            this.d1 = new big(n1).plus(n2);<br>
            this.d2 = new big(n1).minus(n2);<br>
            this.d3 = new big(n1).times(n2);<br>
            this.d4 = new big(n1).div(n2);<br>
                `,
                d1:null,
                d2:null,
                d3:null,
                d4:null,
            }
        },
        created(){
            //加   : plus
            // 减  : minus
            // 乘  : times
            // 除  : div
            var n1 = 0.3;
            var n2 = "0.1";
            this.d1 = new big(n1).plus(n2);
            this.d2 = new big(n1).minus(n2);
            this.d3 = new big(n1).times(n2);
            this.d4 = new big(n1).div(n2);
        }
    }
</script>